module.exports = __webpack_public_path__ + "static/media/oberflex-chenevieillit312-1200x2490.2abf2ff4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-chenevieillit312-1200x2490.jpg
// module id = 998
// module chunks = 37